import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { defineMessages, injectIntl } from 'react-intl';
// eslint-disable-next-line
import OT from 'opentok';

import NavBarConfig from '../../components/NavBarConfig';
import ChatInput from '../../components/video/ChatInput';
import CustomerHeader from './components/CustomerHeader';
import EndCallModal from './components/EndCallModal';
import EventList from './components/event/EventList';
import Loader from '../../components/Loader';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import NoVideoSupport from './components/NoVideoSupport';
import OrderHeader from './components/OrderHeader';
import OrderSidebar from './components/OrderSidebar';
import StartCallModal from './components/StartCallModal';
import UserVideoContainer from './components/UserVideoContainer';
import EditableEventText from './components/EditableEventText';
import AddCallNoteInline from './components/AddCallNoteInline';
import AlternativeCallCard from './components/event/AlternativeCallCard';
import { getAuthToken } from '../../actions/api';
/* global window */

const messages = defineMessages({
  EMAIL_INVITE_BODY: { id: 'CustomerSinglePage.EMAIL_INVITE_BODY', defaultMessage: 'Sehr geehrte Damen und Herren,\n\nhiermit lade ich Sie, wie besprochen, zum Video Call ein.\n\nBitte klicken Sie auf den nachfolgenden Link, um dem virtuellen Raum beizutreten:\n[LINK]\n\nMit freundlichen Grüßen' },
  ERROR_PDF: { id: 'CustomerSinglePage.ERROR_PDF', defaultMessage: 'Fehler beim Generieren des PDFs.' },
  NO_EVENTS: { id: 'CustomerSinglePage.NO_EVENTS', defaultMessage: 'Hier existieren noch keine Einträge.' },
  WAIT_CUSTOMER: { id: 'CustomerSinglePage.WAIT_CUSTOMER', defaultMessage: 'Das Gespräch beginnt sobald sich der Kunde verbindet...' },
  HANG_UP: { id: 'CustomerSinglePage.HANG_UP', defaultMessage: 'Auflegen' },
  EVENT: { id: 'CustomerSinglePage.EVENT', defaultMessage: 'Ereignis' },
  CALL_BEGIN: { id: 'CustomerSinglePage.CALL_BEGIN', defaultMessage: '📞 Gesprächsbeginn' },
  CALL_END: { id: 'CustomerSinglePage.CALL_END', defaultMessage: '🔚 Gesprächsende' },
  PICTURE_UPLOADED: { id: 'CustomerSinglePage.PICTURE_UPLOADED', defaultMessage: '📸 Foto hochgeladen' },
  NOTE: { id: 'CustomerSinglePage.NOTE', defaultMessage: '📝 Notiz' },
  SERVICE_PROTOCOL_PDF: { id: 'CustomerSinglePage.SERVICE_PROTOCOL_PDF', defaultMessage: 'Service-Protokoll (PDF)' },
  PROJECT: { id: 'CustomerSinglePage.PROJECT', defaultMessage: 'Projekt:' },
  ACTIVITIES: { id: 'CustomerSinglePage.ACTIVITIES', defaultMessage: 'Aktivitäten' },
  TOOLTIP_RESIZE: { id: 'CustomerSinglePage.TOOLTIP_RESIZE', defaultMessage: 'Zur besseren Ansicht können Sie diesen Block am linken Rand breiter ziehen.' },
  LOADING_DATA: { id: 'CustomerSinglePage.LOADING_DATA', defaultMessage: 'Lade Daten...' },
  CALL_DURATION: { id: 'CustomerSinglePage.CALL_DURATION', defaultMessage: 'Anruf ({duration}s)' },
  PART_OF_PROJECT: { id: 'CustomerSinglePage.PART_OF_PROJECT', defaultMessage: 'ist Teil von' },
});

import {
  createSMS,
  eventCreated,
  createNote, createNoteWithCall,
  openCallBeginModal,
  closeCallBeginModal,
  openCallEndModal,
  closeCallEndModal,
  setLastCall,
  createEndNote, endNoteCreated,
  addCallToOrder, callAddedToOrder,
  updateCall,
  updateEvent,
  orderList,
  getActiveCall,
  toggleOrderSidebar
} from '../../actions/company';

import {
  activeCallGet,
  createCall,
  callCreated,
  createCallEnd,
  callEndCreated,
  callLeave,
} from '../../actions/video';

import {
  unsubscribe,
  endCall, sendSignal,
  publishScreen, unpublishScreen
} from '../../actions/ot_signaling';

import { createSignature, convertDataUriToImage } from '../../actions/screenshot';

class CustomerSinglePageComponent extends React.Component {
  constructor(props) {
    super(props);

    let browserWithoutVideosupportLocal = false;
    if (/* detectSafariOnOSX() || */ OT.checkSystemRequirements() === 0) {
      browserWithoutVideosupportLocal = true;
    }

    this.state = {
      sendSMS: true,
      sendEmail: false,
      middleHeight: 0,
      orderSideBarActive: false,
      browserWithoutVideosupport: browserWithoutVideosupportLocal,
      rightColWidth: 300,
      isResizing: false,
      signatureModalOpen: false,
      callForPdf: null,
      mobileNotesOpen: false,
    };

    this.wasDesktop = window.innerWidth > 1100;

    this.setMiddleHeight = this.setMiddleHeight.bind(this);
    this.handleCreateSMS = this.handleCreateSMS.bind(this);

    if (!this.props.activeCallFetching) {
      this.props.load();
    }
  }

  componentDidMount() {
    this.setMiddleHeight();
    window.addEventListener('optimizedResize', this.setMiddleHeight);
    
    const isDesktop = window.innerWidth > 1100;
    if (isDesktop) {
      if (!this.props.orderSidebarOpen) {
        this.props.toggleOrderSidebar();
      }
    } else {
      if (this.props.orderSidebarOpen) {
        this.props.toggleOrderSidebar();
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.params.companyId !== nextProps.params.companyId ||
            this.props.params.customerId !== nextProps.params.customerId) {
      nextProps.load();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.orderListFetching !== prevProps.orderListFetching) {
      this.scrollUp();
    }

    if (this.props.params.orderId !== prevProps.params.orderId) {
      this.scrollUp();
    }

    if (this.props.call !== prevProps.call || (
      (this.props.call && prevProps.call) && this.props.call.begin !== prevProps.call.begin
    ) || (this.props.connected !== prevProps.connected)) {
      this.setMiddleHeight();
    }
  }

  componentWillUnmount() {
    const { call } = this.props;
    if (call && !call.call_end) {
      this.props.stopCallWithoutNote(call);
    } else {
      this.props.stopCallConnection();
    }

    window.removeEventListener('optimizedResize', this.setMiddleHeight);
    this.stopResizing();
  }

  startResizing = (e) => {
    e.preventDefault();
    this.setState({ isResizing: true });
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.stopResizing);
    document.body.style.cursor = 'ew-resize';
    document.body.style.userSelect = 'none';
  };

  handleMouseMove = (e) => {
    if (!this.state.isResizing) return;
    let newWidth = window.innerWidth - e.clientX;
    if (newWidth < 300) newWidth = 300;
    if (newWidth > 800) newWidth = 800;
    this.setState({ rightColWidth: newWidth });
  };

  stopResizing = () => {
    this.setState({ isResizing: false });
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.stopResizing);
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  };

  setMiddleHeight() {
    if (this.refs.middle) {
      const { height } = this.refs.middle.getBoundingClientRect();
      this.setState({ middleHeight: height });
    }

    const isDesktop = window.innerWidth > 1100;
    if (isDesktop !== this.wasDesktop) {
      this.wasDesktop = isDesktop;
      if (isDesktop) {
        if (!this.props.orderSidebarOpen) {
          this.props.toggleOrderSidebar();
        }
      } else {
        if (this.props.orderSidebarOpen) {
          this.props.toggleOrderSidebar();
        }
      }
    }
  }

  scrollUp() {
    const { innerMiddle } = this.refs;
    if (typeof innerMiddle !== 'undefined') {
      innerMiddle.scrollTop = innerMiddle.scrollHeight;
    }
  }

  handleStopCall = (withEndNote=true) => {
    const { call } = this.props;
    // load reloads the duration of the active call
    if (withEndNote) {
      this.props.stopCall(call);
    } else {
      this.props.stopCallWithoutNote(call);
    }
  }

  handleCallEndModalSuccess = (data, form) => {
    this.props.closeCallEndModal();
    const { lastCall } = this.props;
    if (data.endNote) {
      const postData = { text: data.endNote };
      if (data.order && data.order !== 'false') {
        postData.orderId = data.order;
      }
      this.props.createEndNote(postData, lastCall, form);
    } else if (data.order && data.order !== 'false') {
      this.props.addCallToOrder(lastCall, { id: data.order });
    }
  }

  handleNoteSubmit = (data, form) => {
    const { call } = this.props;
    if (!call || (call && call.call_end)) {
      this.props.createNote(data, form);
    } else {
      this.props.createNoteWithCall(data, call, form);
    }
  }

  toggleMobileNotes = () => {
    this.setState(prevState => ({
      mobileNotesOpen: !prevState.mobileNotesOpen
    }));
  }

  handleSMSToggle = () => {
    this.setState({ sendSMS: !this.state.sendSMS });
  }

  handleEmailToggle = () => {
    this.setState({ sendEmail: !this.state.sendEmail });
  }

  handleOpenSignatureModal = (id) => {
    this.setState({
      signatureModalOpen: true,
      callForPdf: id
    });
  }

  handleCloseSignatureModal = () => {
    this.setState({
      signatureModalOpen: false,
      callForPdf: null
    });
  }

  handleSaveSignature = (dataUrl) => {
    const { companyId, id: customerId } = this.props.activeCustomer;
    const callId = this.state.callForPdf;
    const blob = convertDataUriToImage(dataUrl);

    return createSignature(companyId, customerId, callId, blob).then(() => {
      return this.props.load();
    });
  }

  handleCreateSMS() {
    const { call } = this.props;
    this.props.createSMS(call);
  }

  handleCallBeginModalSuccess = () => {
    this.props.closeCallBeginModal();
    this.props.createCall().then(() => {
      if (this.state.sendSMS && this.props.customer.phone) {
        this.handleCreateSMS();
      }
      if (this.state.sendEmail) {
        const { company, customer } = this.props;
        let customPages = '';
        if (company && company.hasCustomPages) {
          customPages = `/custom/${company.id}`;
        }
        const callUrl = `${window.location.origin}${customPages}/v/${customer.slug}/`;
        const defaultEmail = this.props.intl.formatMessage(messages.EMAIL_INVITE_BODY);
        const emailTemplate = company && company.email_template ? company.email_template : defaultEmail;
        let emailBody = emailTemplate.replace(/\[LINK\]|\{link\}/gi, callUrl);
        if (!/\[LINK\]|\{link\}/i.test(emailTemplate)) {
          emailBody = emailBody.trim() + '\n\n' + callUrl;
        }
        window.location.href = `mailto:?subject=Einladung zum Video Call&body=${encodeURIComponent(emailBody)}`;
      }
    });
  }

  handleGeneratePdf = (callId) => {
    const token = getAuthToken();
    const { company, customer } = this.props;
    
    // UI Feedback is a bit tricky without state, but we can set a loading flag if needed
    // For now, just trigger the download directly
    fetch(`/api/company/${company.id}/customer/${customer.id}/call/${callId}/pdf`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ signature: null })
    })
    .then(res => {
      if (!res.ok) throw new Error('PDF Generation failed');
      return res.blob();
    })
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Service_Protokoll_Call_${callId}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    })
    .catch(err => {
      console.error(err);
      alert(this.props.intl.formatMessage(messages.ERROR_PDF));
    });
  };

  renderNormalScreen2 = () => {
    const {
      company,
      companyMembership,
      customer,
      connected,
      call,
      activeCallFetching,
      orders,
      callBeginModalActive,
      callEndModalActive,
      lastCall,
      orderListFetching,
      params,
      routes,
    } = this.props;

    const { middleHeight, orderSideBarActive, browserWithoutVideosupport: noVideo } = this.state;
    if (!company || !companyMembership) { return null; }

    const activeCallCreatedAndRunning = call && (!call.call_end || call.call_end_id === -1);
    let showCustomerNotifiedEvent = call && !call.call_begin && !call.call_end && !connected;

    const mappedOrders = orders ? orders.map(o => ({
      ...o,
      calls: (o.calls || []).map(c => ({
        ...c,
        order_id: o.id,
        order_name: o.name,
      })),
      notes: (o.notes || []).map(n => ({
        ...n,
        order_id: o.id,
        order_name: o.name,
      })),
    })) : [];

    const selectedOrderId = parseInt(this.props.params.orderId || -2, 10);
    const order = _.find(mappedOrders, o => o.id === selectedOrderId);

    let middleHeightCalculated = middleHeight;
    if (window.innerWidth < 992) {
      middleHeightCalculated = middleHeight - 50;
    } else if (selectedOrderId > -2) {
      middleHeightCalculated = middleHeight - 68;
    }

    let orderToRender = order;
    if (selectedOrderId === -2) {
      orderToRender = {
        id: -2,
        calls: mappedOrders ? _.flatten(mappedOrders.map(o => o.calls || [])) : [],
        notes: mappedOrders ? _.flatten(mappedOrders.map(o => o.notes || [])) : [],
        active: true,
      };
    }

    const renderAlternativeTimeline = (orderData) => {
      if (!orderData) return <div style={{ padding: '20px', color: '#94a3b8' }}>{this.props.intl.formatMessage(messages.LOADING_DATA)}</div>;
      
      const standaloneNotes = (orderData.notes || []).filter(note => !note.call_id || note.call_id === -1);
      let events = [...standaloneNotes, ...(orderData.calls || [])];
      
      if (showCustomerNotifiedEvent && call) {
        events.push({
          customer_notified: true,
          id: Infinity,
          created: call.created || Date.now()
        });
      }
      
      events = events.sort((a, b) => new Date(b.created || 0) - new Date(a.created || 0));

      if (events.length === 0) return <div style={{ padding: '20px', color: '#94a3b8', textAlign: 'center', marginTop: '20px' }}>{this.props.intl.formatMessage(messages.NO_EVENTS)}</div>;

      return (
        <div style={{ overflowY: 'auto', flex: '1 1 auto', display: 'flex', flexDirection: 'column', gap: '10px', padding: '10px' }}>
          {events.map((evt, i) => {
            if (evt.customer_notified) {
              return (
                <div key={i} style={{ padding: '12px', background: '#332200', border: '1px solid #664400', borderRadius: '12px', color: '#ffcc00' }}>
                  <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px' }}>
                    {this.props.intl.formatMessage(messages.WAIT_CUSTOMER)}
                  </div>
                  <button 
                    onClick={() => this.handleStopCall()} 
                    style={{ background: '#ef4444', color: 'white', border: 'none', borderRadius: '4px', padding: '4px 8px', cursor: 'pointer' }}
                  >
                    {this.props.intl.formatMessage(messages.HANG_UP)}
                  </button>
                </div>
              );
            }
            if (evt.events) {
              return (
                <AlternativeCallCard
                  key={i}
                  call={evt}
                  customer={customer}
                  activeOrders={orders ? orders.filter(o => o.active && o.id !== -1) : []}
                  addCallToOrder={this.props.addCallToOrder}
                  updateEvent={this.props.updateEvent}
                  createNoteWithCall={this.props.createNoteWithCall}
                  handleGeneratePdf={this.handleGeneratePdf}
                  load={this.props.load}
                />
              );
            }

            return (
              <div key={i} style={{ padding: '12px', background: 'var(--panel-bg)', border: '1px solid var(--panel-border)', borderRadius: '12px', color: 'var(--text-color)' }}>
                <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginBottom: '6px' }}>
                  {new Date(evt.created || Date.now()).toLocaleString('de-DE')}
                </div>
                <div style={{ fontSize: '13px' }}>
                  {evt.text && evt.id !== Infinity ? (
                    <EditableEventText 
                      text={evt.text} 
                      eventId={evt.id} 
                      onSave={(id, value) => this.props.updateEvent(id, { text: value }).then(() => this.props.load())} 
                    />
                  ) : (
                    evt.text || evt.message || (evt.events ? this.props.intl.formatMessage(messages.CALL_DURATION, { duration: evt.duration || 0 }) : this.props.intl.formatMessage(messages.EVENT))
                  )}
                  {evt.order_name && (
                    <span>
                      {' '}
                      {this.props.intl.formatMessage(messages.PART_OF_PROJECT)}{' '}
                      <Link
                        title={evt.order_name}
                        style={{ color: 'var(--primary-color)', fontWeight: 500, fontSize: 'inherit' }}
                        to={`/company/${customer.company_id}/customer/${customer.id}/order/${evt.order_id}`}
                      >
                        {evt.order_name}
                      </Link>
                    </span>
                  )}
                </div>
                {/* Bilder direkt am Event */}
                {evt.pictures && evt.pictures.map((pic, j) => (
                  <img key={`pic-${j}`} src={pic.path} alt="Upload" style={{ maxWidth: '100%', borderRadius: '8px', marginTop: '8px' }} />
                ))}
                {/* Verschachtelte Events für Anrufe */}
                {evt.events && evt.events.length > 0 && (
                  <div style={{ marginTop: '10px', paddingLeft: '10px', borderLeft: '2px solid var(--panel-border)' }}>
                    {evt.events.sort((a, b) => new Date(a.created || 0) - new Date(b.created || 0)).map((subEvt, k) => {
                      let label = subEvt.call_event_type;
                      if (label === 'call_begin' || label === 'begin') label = this.props.intl.formatMessage(messages.CALL_BEGIN);
                      else if (label === 'end') label = this.props.intl.formatMessage(messages.CALL_END);
                      else if (label === 'picture') label = this.props.intl.formatMessage(messages.PICTURE_UPLOADED);
                      else if (label === 'note') label = this.props.intl.formatMessage(messages.NOTE);
                      
                      const timeStr = new Date(subEvt.created || Date.now()).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
                      
                      return (
                        <div key={k} style={{ marginBottom: '12px' }}>
                          <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginBottom: '2px' }}>{timeStr}</div>
                          <div style={{ fontSize: '13px' }}>
                            {subEvt.text && subEvt.id !== Infinity && (subEvt.call_event_type === 'note' || subEvt.call_event_type === 'end_note') ? (
                              <EditableEventText 
                                text={subEvt.text} 
                                label={label}
                                eventId={subEvt.id} 
                                onSave={(id, value) => this.props.updateEvent(id, { text: value }).then(() => this.props.load())} 
                              />
                            ) : (
                              subEvt.text ? (
                                <span><strong>{label}:</strong> {subEvt.text}</span>
                              ) : (
                                <strong>{label}</strong>
                              )
                            )}
                          </div>
                          {subEvt.pictures && subEvt.pictures.map((pic, l) => (
                            <img key={`subpic-${l}`} src={pic.path} alt="Upload" style={{ maxWidth: '100%', borderRadius: '8px', marginTop: '6px' }} />
                          ))}
                        </div>
                      );
                    })}
                  </div>
                )}
                {/* PDF Button for Calls */}
                {evt.events && (
                  <div style={{ marginTop: '12px' }}>
                    <AddCallNoteInline 
                      callId={evt.id} 
                      onAddNote={(callId, value) => {
                        return this.props.createNoteWithCall({ text: value }, { id: callId }).then(() => this.props.load());
                      }} 
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '8px', width: '100%' }}>
                      <button 
                        onClick={() => this.handleGeneratePdf(evt.id)}
                        style={{ 
                          fontSize: '12px', 
                          padding: '6px 12px', 
                          marginRight: '8px',
                          color: '#64748b', 
                          background: 'transparent', 
                          border: 'none',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontWeight: 500,
                          transition: 'all 0.2s ease',
                          outline: 'none'
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                      >
                        <i className="fa fa-file-pdf-o" style={{ marginRight: '6px' }}></i>
                        {this.props.intl.formatMessage(messages.SERVICE_PROTOCOL_PDF)}
                      </button>
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="pdf-export-tooltip" style={{ maxWidth: 320, textAlign: 'left', fontSize: 12 }}>
                            Diese PDF-Funktion erstellt ein chronologisches Protokoll über ein oder mehrere geführte Gespräche. Im Gegensatz zum Service-Protokoll ist hierbei keine Unterschrift möglich. Es dokumentiert zudem sämtliche Aktivitäten und Gespräche, die innerhalb des ausgewählten Projektordners (siehe linke Leiste) gespeichert wurden.
                          </Tooltip>
                        }
                      >
                        <span style={{ 
                          display: 'inline-flex', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          width: 16, 
                          height: 16, 
                          borderRadius: '50%', 
                          background: 'var(--primary-color)', 
                          color: 'white', 
                          fontSize: 11, 
                          fontWeight: 'bold', 
                          cursor: 'help'
                        }}>?</span>
                      </OverlayTrigger>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      );
    };

    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', overflow: 'hidden', backgroundColor: 'transparent' }}>
        <NavBarConfig editPage currentRouteName={routes[routes.length - 1].name} hideSidebar={true} />
        
        {!noVideo && (() => {
          let gridColsStyle = {};
          if (this.state.rightColWidth !== 300) {
            gridColsStyle = {
              gridTemplateColumns: this.props.orderSidebarOpen
                ? `220px minmax(300px, 1fr) ${this.state.rightColWidth}px`
                : `minmax(300px, 1fr) ${this.state.rightColWidth}px`
            };
          }
          return (
          <React.Fragment>
          <div 
            className={`customer-dashboard-grid ${this.props.orderSidebarOpen ? 'sidebar-open' : 'sidebar-closed'} ${activeCallCreatedAndRunning || connected ? 'has-active-call' : ''}`}
            style={gridColsStyle}
          >
            
            {/* LEFT COLUMN: Sidebar */}
            <div className={`customer-left-column ${this.props.orderSidebarOpen ? 'active' : ''}`}>
                <OrderSidebar
                  params={this.props.params}
                  selectedOrder={selectedOrderId}
                  middleHeight={middleHeightCalculated}
                  close={this.props.toggleOrderSidebar}
                  active={this.props.orderSidebarOpen}
                />
            </div>

            {/* CENTER COLUMN: Header + Video + Note Input */}
            <div className="customer-center-column">
              {connected ? null : (
                <CustomerHeader
                  activeCallCreatedAndRunning={activeCallCreatedAndRunning}
                  activeCallFetching={activeCallFetching}
                  call={call}
                  connected={connected}
                  customer={customer}
                  handleCreateSMS={this.handleCreateSMS}
                  handleStopCall={this.handleStopCall}
                  openCallBeginModal={this.props.openCallBeginModal}
                  selectedOrderId={selectedOrderId}
                  couldNotCreateCall={noVideo}
                  company={company}
                  toggleSidebar={this.props.toggleOrderSidebar}
                  orderSidebarOpen={this.props.orderSidebarOpen}
                />
              )}
              {/* Permanent video wrapper */}
              <div className="layout-video-area" style={{ flex: 1, minHeight: 0, minWidth: 0, overflow: 'hidden', borderRadius: '18px', background: 'transparent' }}>
                <UserVideoContainer
                  activeCallCreatedAndRunning={activeCallCreatedAndRunning}
                  call={call}
                  closeUserVideo={this.closeUserVideo}
                  handleStopCall={this.handleStopCall}
                  toggleNotes={this.toggleMobileNotes}
                  notesOpen={this.state.mobileNotesOpen}
                  {...this.props}
                />
              </div>
              <div className="desktop-chat-input" style={{ flexShrink: 0 }}>
                <ChatInput onSubmit={this.handleNoteSubmit} />
              </div>
            </div>

            {/* RIGHT COLUMN: Timeline */}
            <div className="customer-right-column desktop-only" style={{ position: 'relative' }}>
              <div 
                className="column-resizer" 
                onMouseDown={this.startResizing}
                style={{
                  position: 'absolute',
                  left: '-4px',
                  top: 0,
                  bottom: 0,
                  width: '8px',
                  cursor: 'ew-resize',
                  zIndex: 10,
                }}
              />
              <div style={{ padding: '16px', borderBottom: '1px solid var(--panel-border)', fontWeight: 'bold', color: 'var(--text-color)', display: 'flex', alignItems: 'center' }}>
                {order && order.id !== -1 && order.id !== -2 ? `${this.props.intl.formatMessage(messages.PROJECT)} ${order.name}` : this.props.intl.formatMessage(messages.ACTIVITIES)}
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="activities-tooltip" style={{ maxWidth: 300, textAlign: 'left' }}>
                      {this.props.intl.formatMessage(messages.TOOLTIP_RESIZE)}
                    </Tooltip>
                  }
                >
                  <span style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    width: 16, 
                    height: 16, 
                    borderRadius: '50%', 
                    background: 'var(--primary-color)', 
                    color: 'white', 
                    fontSize: 11, 
                    fontWeight: 'bold', 
                    cursor: 'help',
                    marginLeft: 8
                  }}>?</span>
                </OverlayTrigger>
              </div>
              {orderListFetching ? (
                <Loader />
              ) : (
                renderAlternativeTimeline(orderToRender)
              )}
            </div>
          </div>

          {/* Mobile Floating Action Button to toggle Notes/Activity (shown when call is not active) */}
          {(!connected || !activeCallCreatedAndRunning) && (
            <button
              type="button"
              className={`mobile-notes-toggle-fab ${this.state.mobileNotesOpen ? 'active' : ''}`}
              onClick={this.toggleMobileNotes}
              title={order && order.id !== -1 && order.id !== -2 ? `${this.props.intl.formatMessage(messages.PROJECT)} ${order.name}` : this.props.intl.formatMessage(messages.ACTIVITIES)}
            >
              <i className="fa fa-file-text-o" />
            </button>
          )}

          {/* Mobile Notes & Activity Overlay (Fade-in / Fade-out Sheet) */}
          <div className={`mobile-notes-overlay ${this.state.mobileNotesOpen ? 'open' : ''}`}>
            <div className="mobile-notes-backdrop" onClick={this.toggleMobileNotes} />
            <div className="mobile-notes-panel">
              <div className="mobile-notes-header">
                <div className="mobile-notes-title">
                  <i className="fa fa-file-text-o" style={{ marginRight: '8px', color: 'var(--primary-color)' }} />
                  {order && order.id !== -1 && order.id !== -2 ? `${this.props.intl.formatMessage(messages.PROJECT)} ${order.name}` : this.props.intl.formatMessage(messages.ACTIVITIES)}
                </div>
                <button
                  type="button"
                  className="mobile-notes-close-btn"
                  onClick={this.toggleMobileNotes}
                  aria-label="Close"
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              <div className="mobile-notes-input-wrapper">
                <ChatInput onSubmit={this.handleNoteSubmit} />
              </div>

              <div className="mobile-notes-timeline-wrapper">
                {orderListFetching ? (
                  <Loader />
                ) : (
                  renderAlternativeTimeline(orderToRender)
                )}
              </div>
            </div>
          </div>
          </React.Fragment>
          );
        })()}

        {!noVideo &&
        <StartCallModal
          open={callBeginModalActive}
          handleModalClose={this.props.closeCallBeginModal}
          toggleSMS={this.handleSMSToggle}
          smsActive={this.state.sendSMS}
          toggleEmail={this.handleEmailToggle}
          emailActive={this.state.sendEmail}
          handleSuccess={this.handleCallBeginModalSuccess}
          customer={customer}
          company={company}
        />
        }
        {!noVideo &&
        <EndCallModal
          open={callEndModalActive}
          handleModalClose={this.props.closeCallEndModal}
          toggleSMS={this.handleSMSToggle}
          smsActive={this.state.sendSMS}
          handleModalSuccess={this.handleCallEndModalSuccess}
          customer={customer}
          orders={orders}
          lastCall={lastCall}
        />
        }
        
        {noVideo &&
        <NoVideoSupport
          browserWithoutVideosupport={noVideo}
          companyId={params.companyId}
          customerId={params.customerId}
        />
        }
      </div>
    );
  }

  render() {
    return this.renderNormalScreen2();
  }
}

export default connect(
  (state) => {
    const {
      customerSingle,
      video: {
        room: {
          remoteConnection: { connected },
          room },
        activeCall: {
          call,
          isFetching: activeCallFetching,
        },
        connection,
        fullsize,
        screenSharing,
      },
      orderList: {
        results,
        isFetching: orderListFetching,
      },
      callBeginModalActive,
      callEndModalActive,
      lastCall,
      orderSidebarOpen,
    } = state;

    return {
      ...customerSingle,
      connected,
      connection,
      call,
      room,
      orderSidebarOpen,
      activeCallFetching,
      orders: results,
      callBeginModalActive,
      callEndModalActive,
      lastCall,
      orderListFetching,
      fullsize,
      screenSharing,
    };
  },
  (dispatch, props) => ({
    createSMS: call => dispatch(
      createSMS(
        props.params.companyId, props.params.customerId, call.id)),
    load: () => dispatch(activeCallGet.load({
      companyId: props.params.companyId,
      customerId: props.params.customerId,
    })),
    createCall: () => createCall(props.params.companyId, props.params.customerId)
      .then((call) => {
        dispatch(callCreated({ call }));
        dispatch(push(`/company/${props.params.companyId}/customer/${props.params.customerId}`));
      }),
    stopCallConnection: () => {
      //console.log('stopCallConnection');
      dispatch(endCall());
      unsubscribe();
    },
    stopCallWithoutNote: (theCall) => {
      const isModerator = (props.room.members.filter(subscriber => props.room.self.connectionId !== subscriber.connectionId).length == 0);
      const signal = isModerator ? 'moderator-end-call' : 'subscriber-leave-call';
      sendSignal(signal, props.room.self.connectionId);
      dispatch(endCall());
      unsubscribe();
      if (isModerator) {
        createCallEnd(props.params.companyId, props.params.customerId, theCall.id)
          .then(({ callEnd, call }) => {
            dispatch(callEndCreated(callEnd));
            dispatch(eventCreated(callEnd));
            dispatch(setLastCall(call));
            dispatch(updateCall(call));
          });
      } else {
        dispatch(setLastCall(theCall));
        dispatch(updateCall(theCall));
        dispatch(callLeave());
      }
    },
    stopCall: (theCall) => {
      const isModerator = (props.room.members.filter(subscriber => props.room.self.connectionId !== subscriber.connectionId && subscriber.type === 'subscriber').length == 0);
      const signal = isModerator ? 'moderator-end-call' : 'subscriber-leave-call';
      sendSignal(signal, props.room.self.connectionId);
      dispatch(endCall());
      unsubscribe();
      if (isModerator) {
        createCallEnd(props.params.companyId, props.params.customerId, theCall.id)
        .then(({ callEnd, call }) => {
          dispatch(callEndCreated(callEnd));
          dispatch(eventCreated(callEnd));
          dispatch(setLastCall(call));
          dispatch(updateCall(call));
          dispatch(openCallEndModal());
        });
      } else {
        dispatch(setLastCall(theCall));
        dispatch(updateCall(theCall));
        dispatch(callLeave());
      }
    },
    createNote: (note, form) => {
      createNote(
        props.params.companyId, props.params.customerId, props.params.orderId || -1, note)
        .then((newNote) => {
          dispatch(eventCreated(newNote));
          if (form) {
            form.reset()
          }
        });
    },
    createNoteWithCall: (data, call, form) => {
      return createNoteWithCall(
        props.params.companyId, props.params.customerId, call.id, data)
        .then((newNote) => {
          dispatch(eventCreated(newNote));
          if (form) {
            form.reset();
          }
          return newNote;
        });
    },
    updateEvent: (eventId, data) => dispatch(updateEvent(eventId, data)),
    updateCall: (callId, data) => dispatch(
      updateCall(props.params.companyId, props.params.customerId, callId, data)
    ),
    createEndNote: (note, call, form) => {
      createEndNote(
        props.params.companyId, props.params.customerId, call.id, note)
        .then((newNote) => {
          dispatch(endNoteCreated(newNote));
          if (form) {
            form.reset();
          }
          dispatch(orderList.load(props.params));
        })
    },
    addCallToOrder: (call, order) => addCallToOrder(
        props.customer.company_id,
        props.customer.id,
        order.id,
        { callId: call.id },
    ).then((orders) => {
      dispatch(callAddedToOrder({ orders }));
    }),
    openCallBeginModal: () => {
      // check if have an active call remote
      getActiveCall(
        props.params.companyId,
        props.params.customerId,
      ).then((call) => {
        if (call && (!call.call_end || call.call_end_id === -1)) {
          //console.log('openCallBeginModel %o', call);
          dispatch(activeCallGet.success(call));
        } else {
          //console.log('no call found %o', call);
          dispatch(openCallBeginModal());
        }
      });
    },
    closeCallEndModal: () => {
      dispatch(closeCallEndModal());
      dispatch(callLeave());
    },
    ...bindActionCreators({
      closeCallBeginModal,
      openCallEndModal,
      publishScreen,
      unpublishScreen,
      toggleOrderSidebar,
    }, dispatch),
  })
)(injectIntl(CustomerSinglePageComponent));
